import { PendingTestKitsProps, TestKitType } from "@/common/types";
import { getKitsPendingTesting } from "@/redux/actions/homeActions";
import { RootState } from "@/redux/reducers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MarkInProgress from "@/containers/test-detail/workflows/mark-in-progress";

const PendingTestKits: React.FC<PendingTestKitsProps> = ({ updateStats }) => {
  const dispatch: any = useDispatch();

  const { kitsPendingTesting } = useSelector((state: RootState) => state.home);

  const updatePendingTestKits = () => {
    dispatch(getKitsPendingTesting());
  };

  useEffect(() => {
    dispatch(getKitsPendingTesting());
  }, []);

  return (
    <div className="w-full h-full flex flex-col border rounded-md">
      <p className="font-bold px-4 pt-4 pb-2 border-b">Kits Pending Testing</p>
      {(kitsPendingTesting as TestKitType[]).length > 0 &&
        (kitsPendingTesting as TestKitType[]).map((testKit) => (
          <div
            key={testKit.id}
            className="flex items-center justify-between gap-2 px-4 py-2"
          >
            <div>{testKit.kit_id}</div>
            <MarkInProgress
              testKitId={testKit.id}
              callback={() => {
                updatePendingTestKits();
                if (updateStats) {
                  updateStats();
                }
              }}
            />
          </div>
        ))}
      {(kitsPendingTesting as TestKitType[]).length === 0 && (
        <div className="flex items-center  gap-2 px-4 py-2 h-full">
          <p className="text-sm">No kits pending testing</p>
        </div>
      )}
    </div>
  );
};

export default PendingTestKits;
